module.exports = __webpack_public_path__ + "img/11crmage.84a3c738.png";